import { AnyAction } from "redux";
import { GET_MANAGEMENT_COMPANY_FAILURE, GET_MANAGEMENT_COMPANY_REQUEST, GET_MANAGEMENT_COMPANY_SUCCESS } from "../constants/management-company.constants";

const initialState = {
    loading: false,
    data: [],
    error: '',
};

export const managementCompanyReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case GET_MANAGEMENT_COMPANY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_MANAGEMENT_COMPANY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case GET_MANAGEMENT_COMPANY_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
}